import { BlurView } from 'expo-blur'
import { LinearGradient } from 'expo-linear-gradient'
import { View, Text } from 'react-native'
import { cardImageStyle } from '@/src/app/main/(tabs)/card/card-management/virtual-card/cardImageStyle'
import Svg, { G, Path, type SvgProps } from 'react-native-svg'
import { mesaColorNames, typography } from '@/src/common/theme'

function AccountInReviewIcon(props: SvgProps) {
  return (
    <Svg width={20} height={19} viewBox="0 0 20 19" fill="none" {...props}>
      <G stroke="#fff" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <Path d="M15.542 2.375H4.458c-.874 0-1.583.709-1.583 1.583v11.084c0 .874.709 1.583 1.583 1.583h11.084c.874 0 1.583-.709 1.583-1.583V3.958c0-.874-.709-1.583-1.583-1.583z" />
        <Path d="M2.875 7.126a1.583 1.583 0 011.583-1.583h11.084a1.584 1.584 0 011.583 1.583M2.875 8.707H5.25c.633 0 1.267.238 1.662.713l.871.712a3.154 3.154 0 004.513 0l.87-.712c.396-.396 1.03-.713 1.663-.713h2.296" />
      </G>
    </Svg>
  )
}

export function AccountInReview() {
  return (
    <View
      style={[
        cardImageStyle,
        {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        },
      ]}
    >
      <View style={{ opacity: 0.92, height: '100%', width: '100%', position: 'absolute' }}>
        <BlurView
          intensity={8}
          style={{ height: '100%', width: '100%', position: 'absolute' }}
          experimentalBlurMethod="dimezisBlurView"
        />
        <LinearGradient
          colors={[
            `${mesaColorNames['Mesa - Brand/Secondary #223843']}00`,
            `${mesaColorNames['Greyscale/900 #152438']}75`,
            mesaColorNames['Greyscale/900 #152438'],
          ]}
          locations={[0, 0.45, 1]}
          style={{ height: '100%', width: '100%', position: 'absolute' }}
        />
      </View>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'flex-start' }}>
        <AccountInReviewIcon height={18} />
        <View style={{ display: 'flex', flexDirection: 'column', width: 287 }}>
          <Text
            style={[typography['XS Bold'], { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }]}
          >
            Account is in review
          </Text>
          <Text style={[typography.XS, { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }]}>
            Your account has been flagged for review, please contact support for updates.
          </Text>
        </View>
      </View>
    </View>
  )
}
